import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_PETITIONS_IN_FOOTER_WELL = defineFcm('promoted_petitions_in_footer_well')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-middle-end',
		context: 'search page',
		description:
			'Indicates whether to display promoted petitions in the footer well on petition details or search page.',
		import: false,
	});
